import { render, staticRenderFns } from "./text-field-primary.vue?vue&type=template&id=a07cf020&scoped=true&"
import script from "./text-field-primary.vue?vue&type=script&lang=js&"
export * from "./text-field-primary.vue?vue&type=script&lang=js&"
import style0 from "./text-field-primary.vue?vue&type=style&index=0&id=a07cf020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07cf020",
  null
  
)

export default component.exports